import { render, staticRenderFns } from "./PageSettings.vue?vue&type=template&id=481638f7&scoped=true"
import script from "./PageSettings.vue?vue&type=script&lang=js"
export * from "./PageSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481638f7",
  null
  
)

export default component.exports